// 前后端共享类型定义

export interface AgentSnapshot {
  id: string;
  name: string;
  x: number;
  y: number;
  color: string;
  hat: string;
  activity: string; // 当前行为描述
  emoji: string; // 当前行为图标
  bubble: string | null; // 说话气泡
  isPlayer: boolean;
  isNPC: boolean;
  moving: boolean;
  dir: "up" | "down" | "left" | "right";
}

export interface WorldState {
  width: number;
  height: number;
  tiles: number[]; // 渲染用 tile 编码
  day: number;
  gameMin: number; // 当天第几分钟 0-1439
  weather: string; // sunny / cloudy / rain
  llmActive: boolean;
  online: number;
}

export interface Post {
  id: number;
  agentId: string | null;
  agentName: string;
  agentColor: string;
  kind: "diary" | "goal" | "highlight" | "system" | "player";
  content: string;
  day: number;
  gameMin: number;
  createdAt: number;
}

export interface AgentProfile {
  id: string;
  name: string;
  isNPC: boolean;
  color: string;
  hat: string;
  personality: string;
  backstory: string;
  wish: string;
  occupation: string;
  goalLong: string;
  goalShort: string;
  activity: string;
  memories: { content: string; day: number; gameMin: number; type: string }[];
  memoriesTotal: number;
}

export interface BoardMessage {
  id: number;
  agentId: string | null;
  name: string;
  content: string;
  ts: number;
  isGuest: boolean;
}

export interface BoardQuota {
  isGuest: boolean;
  limit: number;
  used: number;
}

export interface ChatMsg {
  id: number;
  role: "user" | "agent";
  content: string;
  createdAt: number;
}

export interface Building {
  id: string;
  name: string;
  x: number;
  y: number;
  w: number;
  h: number;
  doorX: number;
  doorY: number;
  color: string;
  emoji: string;
  desc: string;
  open: boolean; // 是否可进入(露天区域)
}

// tile 编码
export const T = {
  GRASS: 0,
  PATH: 1,
  WATER: 2,
  TREE: 3,
  FLOWER: 4,
  FARM: 5,
  WALL: 6,
  DOOR: 7,
  FOUNTAIN: 8,
  STONE: 9,
  SAND: 10,
  CAMPFIRE: 11,
  BENCH: 12,
  CROPS: 13,
  STUMP: 14,
} as const;

export const WEATHERS: Record<string, { name: string; emoji: string }> = {
  sunny: { name: "晴朗", emoji: "☀️" },
  cloudy: { name: "多云", emoji: "⛅" },
  rain: { name: "细雨", emoji: "🌧️" },
};
